module.exports = __webpack_public_path__ + "static/img/videocall.ccb089ad.svg";